module.exports = __webpack_public_path__ + "static/Hexowatch-logo-c7ca633266845f503e50bd9e747d24a8.pdf";